import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { Tab, Tabs, TabsTheme } from '@shared/components/tabs';
import { SuccessStory } from '@shared/components/successStory';
import { urlReplace, routes } from '@shared/routerHistory';
import { marketplaceTestimonials, testimonials } from './Testimonials.data';
import { OwnerType } from '@shared/utils/detailUtils';
const biArea = 'homePage';
export const Testimonials = ({ defaultTestimonialTabName, isConverged }, context)=>{
    const getSuccessStoryTabHref = (tabId)=>{
        const params = {
            filterTab: null,
            successStoryTab: tabId,
            industry: null
        };
        return context === null || context === void 0 ? void 0 : context.buildHref(routes.home, null, params);
    };
    const changeSuccessStoryTabCallback = (tabId)=>{
        const newPath = getSuccessStoryTabHref(tabId) || '';
        urlReplace(newPath);
    };
    return /*#__PURE__*/ _jsx(Tabs, {
        defaultTab: defaultTestimonialTabName,
        ownerType: OwnerType.App,
        theme: TabsTheme.gray,
        ownerId: 'homeSuccessStory',
        centerize: true,
        changeTabCallback: (tabId)=>{
            changeSuccessStoryTabCallback(tabId);
        },
        getTabHref: (tabId)=>getSuccessStoryTabHref(tabId),
        children: (isConverged ? marketplaceTestimonials : testimonials).map((story)=>{
            const { title, id, author, description, descriptionFallback, image, recommendations } = story;
            return /*#__PURE__*/ _jsx(Tab, {
                title: context.loc(title, title),
                name: id,
                otherProps: {
                    'data-bi-id': id,
                    'data-bi-type': 'successStory',
                    'data-bi-area': biArea
                },
                children: /*#__PURE__*/ _jsx(SuccessStory, {
                    author: author,
                    description: description,
                    descriptionFallback: descriptionFallback,
                    id: id,
                    image: image,
                    recommendations: recommendations,
                    title: title,
                    isConverged: isConverged
                })
            }, id);
        })
    });
};
Testimonials.contextTypes = {
    buildHref: PropTypes.func,
    loc: PropTypes.func
};
